import React, { useEffect } from 'react'
import { IAction } from '../../../../types/action';
import { NOTIFICATION_ACTIONS } from '../../../../data/notification';
interface IActionProps {
    handleSaveAction: (e: React.FormEvent<HTMLFormElement>, action: IAction) => void;
    handleDeleteAction: (id?: number) => void;
    isAddAction: boolean;
    isDelete: boolean;
    setIsDelete: React.Dispatch<React.SetStateAction<boolean>>;
    currentOption: number[];
    setCurrentOption: React.Dispatch<React.SetStateAction<number[]>>;
    isProcessRunning: boolean;
    actions: IAction[];
}
const Action = ({ handleSaveAction, handleDeleteAction, currentOption, isAddAction, isDelete, setIsDelete, isProcessRunning, actions }: IActionProps) => {
    const blankAction = { name: "", link: "" };
    const [currentAction, setCurrentAction] = React.useState<IAction>(blankAction);
    const [title, setTitle] = React.useState<string>('New Action');

    useEffect(() => {
        if (isAddAction) {
            setCurrentAction(blankAction);
            setTitle('New Action');
        } else {
            if (actions && currentOption.length === 2) {
                const action = actions[currentOption[1]];
                setCurrentAction(action);
                setTitle(action.name);
            }
        }
    }, [actions, isAddAction, currentOption]); // eslint-disable-line

    if (!currentAction) return <p>Loading ...</p>
    return (
        <div className='imm_admin__content'>
            <div className='content_head'>
                <h3>{title}</h3>
            </div>

            <form onSubmit={(e) => handleSaveAction(e, currentAction)} className='content_form'>
                <div className='field'>
                    <label htmlFor='action'>Title <span className='field__required'>*</span></label>
                    <input id='action' name='action' placeholder='Enter action name' value={currentAction.name || ''} onChange={(e) => setCurrentAction({ ...currentAction, name: e.target.value })} />
                </div>
                <div className='field'>
                    <label htmlFor='link'>Link <span className='field__required'>*</span></label>
                    <select id='link' name='link' value={currentAction.link || ''} onChange={(e) => setCurrentAction({ ...currentAction, link: e.target.value })}>
                        <option value="">Select link</option>
                        {NOTIFICATION_ACTIONS.map((action, index) => <option key={index} value={action.value}>{action.key}</option>)}
                    </select>
                </div>

                <div className='actions'>
                    <button disabled={isProcessRunning} className='delete_btn' type="button" onClick={() => handleDeleteAction(currentAction.id)}>{!currentAction.id ? 'Cancel' : 'Delete'}</button>
                    <button disabled={isProcessRunning} className='save_btn' type='submit'>{isProcessRunning ? <i className='imm_admin__process_loader' /> : !currentAction.id ? 'Create' : 'Save'}</button>
                </div>
            </form>
        </div>
    )
}

export default Action;